<template>
  <div class="get-employee-page">
    <page-cover :cover="cover" v-if="cover" />
    <GetEmployeePage />
  </div>
</template>
<script>
import PageCover from "@/components/shared/PageCover.vue";
import GetEmployeePage from "@/components/get-employee/GetEmployeePage.vue";
import { mapGetters } from "vuex";

export default {
  name: "GetEmployee",
  computed: {
    ...mapGetters({
      cover: "pageCover/getNurse",
    }),
  },
  components: {
    PageCover,
    GetEmployeePage,
  },
};
</script>